import { useIntl } from 'react-intl'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import LoyaltyBurnPriceDisplay from 'loyalty/components/LoyaltyBurnPriceDisplay'
import { getExperienceTileSaleUnit } from 'lib/experiences/getExperienceTileSaleUnit'
import type { SearchOfferBurnPricing } from 'hooks/useSearchOfferBurnPricing'
import ExperienceTilePrices from './ExperienceTilePrices'

interface Props {
  tileBurn: SearchOfferBurnPricing
  totalPrice?: number
  totalMemberPrice?: number
  totalGrossPrice?: number
  discountPercentage?: number
  isFromPrice: boolean
  showFromCaption?: boolean
  ticketUnitLabel: string
  size?: 'S' | 'L' | 'M'
  nonMemberPriceSize?: 'L' | 'M'
  discountMemberPercentage?: number
}

function ExperienceTilePricesWithBurn(props: Props) {
  const {
    tileBurn,
    totalPrice,
    totalMemberPrice,
    totalGrossPrice,
    discountPercentage,
    isFromPrice,
    showFromCaption = true,
    ticketUnitLabel,
    size = 'S',
    nonMemberPriceSize = 'M',
    discountMemberPercentage,
  } = props

  const intl = useIntl()
  const {
    viewPriceInPoints,
    isSocietePricingActive,
    showMemberPricing,
    burnEnabled,
    priceInPoints,
    memberPriceInPoints,
    pointsToBurn,
    pointsOnly,
    hideZeroCash,
    shouldShowBurn,
  } = tileBurn

  const fromCaption = intl.formatMessage({
    id: 'EAQ_GV7KRwveLWB08EmL',
    defaultMessage: 'From',
    description: 'Price caption prefix on the experience tile prices',
  })
  const totalLabel = intl.formatMessage({
    id: 'whMf0sOzbI-AWwhc2zR7',
    defaultMessage: 'total',
    description: 'Sale unit label for total price on experience tile prices',
  })
  const saleUnit = getExperienceTileSaleUnit({ isFromPrice, ticketUnitLabel, totalLabel })

  const cashPrices = (
    <ExperienceTilePrices
      totalPrice={totalPrice}
      totalMemberPrice={totalMemberPrice}
      totalGrossPrice={totalGrossPrice}
      discountPercentage={discountPercentage}
      isFromPrice={isFromPrice}
      showFromCaption={showFromCaption}
      ticketUnitLabel={ticketUnitLabel}
      size={size}
      nonMemberPriceSize={nonMemberPriceSize}
      discountMemberPercentage={discountMemberPercentage}
    />
  )

  const isBurnPricingLoading = isSocietePricingActive && (
    !burnEnabled
    || (showMemberPricing && memberPriceInPoints === undefined)
  )

  if (isBurnPricingLoading) {
    if (viewPriceInPoints) return cashPrices
    return isFromPrice && showFromCaption ? <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption> : null
  }

  if (shouldShowBurn) {
    return (
      <>
        {isFromPrice && showFromCaption && <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption>}
        <LoyaltyBurnPriceDisplay
          totalPrice={totalPrice ?? 0}
          pointsToBurn={pointsToBurn}
          priceInPoints={priceInPoints}
          memberPrice={totalMemberPrice}
          memberPriceInPoints={memberPriceInPoints}
          size={size}
          saleUnit={saleUnit}
          pointsOnly={pointsOnly}
          hideZeroCash={hideZeroCash}
        />
      </>
    )
  }

  return cashPrices
}

export default ExperienceTilePricesWithBurn
